import React from 'react';
import { ExternalLink, FileText } from 'lucide-react';
import { TITRE_GUIDE_URL } from '../lib/titreGuide';

export const ImportTitreGuideLink = () => (
  <div data-testid="import-titre-guide-download" className="mb-5">
    <a
      href={TITRE_GUIDE_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="import-titre-guide-link"
      className="inline-flex max-w-full items-center gap-3 rounded-lg border border-primary/40 bg-primary/5 px-4 py-3 text-left text-sm font-semibold leading-relaxed text-teal-800 transition-colors hover:bg-primary/10 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal-800"
    >
      <FileText aria-hidden="true" className="h-5 w-5 shrink-0" />
      <span data-testid="import-titre-guide-link-label" className="min-w-0 break-words">
        View Titre Test Exemption Guide (PDF)
      </span>
      <ExternalLink aria-hidden="true" className="h-4 w-4 shrink-0" />
    </a>
    <a href="/titre-test-exemptions" data-testid="import-titre-guide-public-page" className="mt-3 block w-fit text-sm font-semibold text-teal-800 underline underline-offset-4 hover:text-teal-950">
      Read and share the online guide
    </a>
  </div>
);